import React from 'react'
import { useIntl } from 'react-intl'
import { Icons } from 'msp-components'
import { useNavigation } from 'msp-integrations'
import * as S from './AccountLogout.styles'
import * as T from './AccountLogout.types'

const AccountLogout = ({ customer }: T.AccountLogoutProps) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigation()
  const onSignoutClick = async () => {
    await customer.logout()
    navigate('/login')
  }

  return (
    <>
      <div className={S.AccountLogoutWrapper}>
        <div className={S.AccountLogoutCustomerName}>
          {`${customer.firstName} ${customer.lastName}`}
        </div>
        <div className={S.AccountLogoutButton} onClick={onSignoutClick}>
          <Icons iconName='Logout' height='20px' width='20px' />
          {formatMessage({
            defaultMessage: 'Logout',
            id: 'account.logout_button.button.log_out'
          })}
        </div>
      </div>
    </>
  )
}

export default AccountLogout
